// extracted by mini-css-extract-plugin
module.exports = {"main":"parsing-loader_main__2qe2Q"};